<div class="pad-hack"></div>
<div
  #convoBubblesArea
  class="convo-bubbles-area"
>
  @if (stepCollections.length > 0) {
    @for (collection of stepCollections; track collection.instanceId; let i = $index) {
      <moti-convo-bubble-group
        [readyToRender]="true"
        [readyToAction]="!waitingForResponse"
        [steps$]="collection.steps$"
        [stepDeletions$]="collection.stepDeletions$"
        [stepPrimaryChanges$]="collection.stepPrimaryChanges$"
        [isLatestStep]="stepCollections.length - 1 === i"
        [user]="user"
        [showModel]="showModelMenu"
        [modelOrder]="modelOrder"
      ></moti-convo-bubble-group>
    }
  } @else if (!loadedOnce) {
    <div class="loading-container">
      <i class="far fa-spin fa-loader"></i>
    </div>
  } @else {
    <moti-empty-section-placeholder
      [htmlText]="'Start a conversation by typing a message below.'"
      [faIconName]="'fa-kit fa-chat'"
    ></moti-empty-section-placeholder>
  }

  <div
    #scrollBottom
    class="text-input-buffer"
    [style.height.px]="textInputBufferHeight"
  ></div>

  @if (showScrollToBottomButton) {
    <button
      class="scroll-to-bottom-button"
      (click)="onScrollToBottomClick()"
      aria-label="Scroll to bottom"
    >
      @if (newMessagesCount > 0) {
        <span class="new-messages-badge">
          {{ newMessagesCount }}
        </span>
      }
      <i class="fa-regular fa-chevron-down"></i>
    </button>
  }
</div>


<div
  #textInputArea
  class="text-input-area"
>
  @if (!ended && canChat) {
    <div class="multi-user-status">
      @if (canViewUsers && userIds.length > 1) {
        <a
          class="user-count"
          [routerLink]="MotiUrlService.getConvoUsersUrl(convo.id)"
        >
          {{ userIds.length }} <i class="fa-solid fa-user"></i>
        </a>
      }

      @if (shouldShowDeferResponseState) {
        <div class="at-moti-info">
          @if (!shouldDeferResponse) {
            Moti will respond to this message
            <span class="green" [innerHTML]="checkIconHtml"></span>
          } @else {
            Add <strong (click)="addAtMotiToInput()">&#64;moti</strong> to prompt Moti to respond
            <span class="fuchsia">
              <moti-info-circle [infoHtml]="getAtMotiInfoMessage()"></moti-info-circle>
            </span>
          }
        </div>

        <div class="contributors">
          @for (userId of contributorIds; track userId) {
            <motn-user-avatar
              [user]="getContributorUser(userId)"
              size="small"
            ></motn-user-avatar>
          }
        </div>
      }
    </div>
  }

  @if (ended === false) {
    <div class="inputs">
      @if (!canChat) {
        You are a viewer in this convo
        <moti-info-circle
          [infoText]="viewOnlyInfoMessage"
        ></moti-info-circle>
      } @else {
        <div
          #textInput
          class="input"
          contenteditable="true"
          [(ngModel)]="userEntry"
          (keyup)="onInputChange()"
          (keydown.enter)="onPressEnter($event)"
        ></div>

        <button
          class="send-button"
          [class.loading]="status?.waitingForProvider"
          (click)="submit()"
        >
          <span>Send</span>
          <motn-spinner></motn-spinner>
        </button>
      }
    </div>
  }


  @if (ended) {
    <div class="inputs">
      <div>
        This convo has ended
      </div>

      <moti-info-circle
        [infoText]="'Convos using our old AI engine, kallm1, are no longer supported.\n\nOur newest AI engine, kallm2, introduced in Feb. 2024, is faster, more reliable, and better at finding the most important information in your sources.\n\nAll new convos started since the release of kallm2 use kallm2.'"
      ></moti-info-circle>

      <a
        [routerLink]="'/convos'"
        class="button small fuchsia"
      >
        View My Convos
      </a>
    </div>
  }
</div>
